<template>
  <svg
    aria-hidden="true"
    class="my-24 mx-16 fill-brand"
    width="30"
    height="30"
    viewBox="0 0 30 30"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7 0H5V2H2C0.89543 2 0 2.89543 0 4V28C0 29.1046 0.89543 30 2 30H28C29.1046 30 30 29.1046 30 28V4C30 2.89543 29.1046 2 28 2H25V0H23V2H7V0ZM23 4H25H28V6H2V4H5H7H23ZM2 8V28H28V8H2ZM21.2318 15.9638C20.6526 13.4727 18.1026 12 15.8224 12C15.2701 12 14.8224 11.5523 14.8224 11C14.8224 10.4477 15.2701 10 15.8224 10C18.9391 10 22.3576 11.9743 23.1798 15.5108C23.8058 18.203 22.976 20.5866 21.3846 22.2604H23C23.5523 22.2604 24 22.7081 24 23.2604C24 23.8127 23.5523 24.2604 23 24.2604H18.5C17.9477 24.2604 17.5 23.8127 17.5 23.2604V18.7604C17.5 18.2081 17.9477 17.7604 18.5 17.7604C19.0523 17.7604 19.5 18.2081 19.5 18.7604V21.2937C20.9377 20.0612 21.7418 18.1574 21.2318 15.9638ZM14.0009 23.2605C11.7208 23.2605 9.17071 21.7878 8.59154 19.2968C8.08162 17.1036 8.88524 15.2002 10.3224 13.9676V16.5C10.3224 17.0523 10.7701 17.5 11.3224 17.5C11.8747 17.5 12.3224 17.0523 12.3224 16.5V12C12.3224 11.4477 11.8747 11 11.3224 11H6.82239C6.2701 11 5.82239 11.4477 5.82239 12C5.82239 12.5523 6.2701 13 6.82239 13H8.43891C6.84739 14.6738 6.01754 17.0574 6.6435 19.7497C7.46576 23.2862 10.8843 25.2605 14.0009 25.2605C14.5532 25.2605 15.0009 24.8128 15.0009 24.2605C15.0009 23.7082 14.5532 23.2605 14.0009 23.2605Z"
    />
  </svg>
</template>
<script lang="ts">
export default {
  name: 'RegularScheduleIcon',
};
</script>
